var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm9.52,10.8H13.2V2.48A9.61,9.61,0,0,1,21.52,10.8ZM2.4,12a9.61,9.61,0,0,1,8.4-9.52v19A9.61,9.61,0,0,1,2.4,12Zm10.8,9.52V13.2h8.32A9.61,9.61,0,0,1,13.2,21.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.ea8098117f758dcd298bdbf5b01e092b.svg";
export { ForwardRef as ReactComponent };